




































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

import BriocheImageTag from 'frontend/components/BriocheImageTag.vue';

@Component({
  components: {
    BriocheImageTag,
  },
  computed: {
    ...mapState('categorizedCoursesByDifficulty', {
      categorizedCoursesByDifficulty: ({ items }: { items: object[] }) => items,
    }),
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class WhatCanILearn extends Vue {
  @Prop(Boolean) private readonly onTrialPaywall!: boolean | undefined;
}
